/* eslint-disable camelcase */
import * as marietta from '../..';
import MasterItemCollection from './MasterItemCollection';
import DocumentCollection from './DocumentCollection';

class PointCollection {
    x: number;

    y: number;

    wall_type: number;

    road_w: number = 0;

    road_lr: boolean = false;

    type: number;

    guid:string;

    inner_end_item_info:MasterItemCollection;
    outer_end_item_info:MasterItemCollection;
    habaki_end_item_info:MasterItemCollection;

    inner_white_item_info:MasterItemCollection;
    outer_white_item_info:MasterItemCollection;
    habaki_white_item_info:MasterItemCollection;

    wall_documents:DocumentCollection[];
    habaki_documents:DocumentCollection[];


    material : { inner: string, outer: string }={ inner: null, outer: null };

    /**
     * コンストラクタ
     * guid未指定時は空文字のままにせず、その場でGUIDを採番して確定させる。
     * 空文字guidのまま保存すると、読込時(WebcadJSONParser)がtruthyチェックで
     * 空文字を「無し」とみなして毎回新規GUIDを再採番してしまい、
     * plan.quotation側のguid参照（見積算入チェック）と再読込のたびに不一致になる。
     */
    constructor(numX: number = NaN, numY: number = NaN, type: number = NaN, guid: string = '') {
      this.x = numX;
      this.y = numY;
      this.wall_type = type;
      this.guid = guid || marietta.webcad.WebCADGlobal.getGuid();
    }

    /**
     * クローン
     * @return marietta.webcad.collection.PointCollection
     */
    clone(newGuid: boolean = false): marietta.webcad.collection.PointCollection {
      const ret: marietta.webcad.collection.PointCollection = new marietta.webcad.collection.PointCollection(this.x, this.y, this.wall_type);
      ret.x = this.x;
      ret.y = this.y;
      ret.wall_type = this.wall_type;
      ret.road_w = this.road_w;
      ret.road_lr = this.road_lr;
      ret.type = this.type;
      if (newGuid) {
        ret.guid = marietta.webcad.WebCADGlobal.getGuid();
      } else {
        ret.guid = this.guid;
      }
      ret.material = { ...this.material };
      ret.outer_end_item_info = this.outer_end_item_info;
      ret.inner_end_item_info = this.inner_end_item_info;
      ret.habaki_end_item_info = this.habaki_end_item_info;
      ret.wall_documents = this.wall_documents;
      ret.habaki_documents = this.habaki_documents;
      return ret;
    }

    /**
     * ポイント情報の取得
     * */
    get point(): marietta.core.Point { return new marietta.core.Point(this.x, this.y); }
}
export default PointCollection;
